<template>
    <div class="AccountAut">
        <div class="title">
            <div class="topbar">
                <span class="par_page">账号管理&nbsp;/&nbsp;</span>
                <span class="current_page">账户授权</span>
            </div>
            <el-tabs v-model="activeName" type="border-card" @tab-click="handleClick">
                <el-tab-pane label="巨量" name="juliangTabPane">
                    <span slot="label">
                        <span>巨量</span>
                    </span>
                    <el-menu
                        :default-active="activeIndex"
                        mode="horizontal"
                        @select="handleMenuSelect">
                        <el-menu-item index="1" class="leftmargin">管家账号</el-menu-item>
                        <el-menu-item index="2" class="leftmargin">广告主账号</el-menu-item>
                    </el-menu>
                </el-tab-pane>
                <el-tab-pane label="千川" name="qianchuanTabPane">
                    <span slot="label">
                        <span>千川</span>
                    </span>
                    <el-menu
                        :default-active="activeIndex"
                        mode="horizontal"
                        @select="handleMenuSelect">
                        <el-menu-item index="1" class="leftmargin">管家账号</el-menu-item>
                        <el-menu-item index="2" class="leftmargin">广告主账号</el-menu-item>
                    </el-menu>
                </el-tab-pane>
            </el-tabs>
        </div>
        <div v-if="activeIndex === '1'">
            <div class="search_top">
                <div class="search_box">
                    <div>
                        <el-input
                            v-model.trim="accountQueryInfo.account_id"
                            class="search_input"
                            placeholder="管家账户ID"
                            clearable>
                        </el-input>
                        <el-input
                            v-model.trim="accountQueryInfo.advertiser_name"
                            class="search_input leftmargin3"
                            placeholder="账号名称"
                            clearable>
                        </el-input>
                        <el-select
                            class="search_input leftmargin3"
                            clearable
                            v-model="accountQueryInfo.account_state"
                            placeholder="账号状态">
                            <el-option :label="'异常'" :value="0"></el-option>
                            <el-option :label="'正常'" :value="1"></el-option>
                        </el-select>
                        <el-button
                            type="primary"
                            @click="getAccountList(1)"
                            class="leftmargin2"
                            size="small">查询
                        </el-button>
                    </div>
                    <el-button v-if="activeIndex==='1'" type="primary" size="small" @click="showAddDialog">新增广告账号</el-button>
                </div>
            </div>
            <div class="search_top">
                <div class="account_box">
                    <div class="account_title">
                        <div>管家账号详情</div>
                        <el-button class="refresh el-icon-refresh-right" size="small" :loading="loading" @click="getAccountList(2)"></el-button>
                    </div>
                    <el-table
                        :data="accountList"
                        v-loading="loading"
                        element-loading-text="加载中..."
                        style="width: 100%; margin-bottom: 22px; font-size: 14px"
                        :header-cell-style="tableHeaderStyle"
                        :cell-style="{ height: 54 + 'px', padding: 0 + 'px' }">
                        <el-table-column prop="account_id" label="ID" width="150"></el-table-column>
                        <el-table-column prop="advertiser_name" min-width="200" label="账号名称">
                            <template slot-scope="scope">
                                {{scope.row['qc_ad_advertiser_account.advertiser_name'] || scope.row.advertiser_name}}
                            </template>
                        </el-table-column>
                        
                        <el-table-column prop="account_state" width="140" label="账户状态">
                            <template slot-scope="scope">
                                <span v-if="scope.row.account_state === '异常'" class="abnormal">异常</span>
                                <span v-else class="normal">正常</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="valid_endTime" min-width="180" label="授权截止时间">
                            <template slot-scope="scope">
                                {{ scope.row['valid_endTime'] | formatTime }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="create_time" width="180" label="创建时间">
                            <template slot-scope="scope">
                                {{ scope.row.create_time | formatTime }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="-" label="操作" min-width="300">
                            <template slot-scope="scope">
                                <!-- <el-button type="text">添加广告主</el-button> -->
                                <!-- <i class="el-icon-more"></i> -->
                                <!-- <el-button type="text">重新绑定</el-button>
                                <el-button type="text">自动绑定</el-button>
                                <el-button type="text">停投</el-button>
                                <el-button type="text">编辑</el-button>
                                <el-button type="text">删除</el-button> -->
                                <el-button type="text" @click="syncData(scope.row,scope.$index)" :loading="syncLoding&&syncIndex==scope.$index">同步</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <kt-pag
                        :pageCount="accountQueryInfo.count"
                        :currentPage="accountQueryInfo.page"
                        :limit="accountQueryInfo.limit"
                        @onChange="handlePageChange">
                    </kt-pag>
                </div>
            </div>
        </div>

        <div v-if="activeIndex === '2'">
            <div class="search_top">
                <div class="search_box">
                    <div>
                        <el-input
                            v-model.trim="advertiserForm.advertiser_id"
                            class="search_input"
                            placeholder="广告主账户ID"
                            clearable>
                        </el-input>
                        <el-input
                            v-model.trim="advertiserForm.advertiser_name"
                            class="search_input leftmargin3"
                            placeholder="广告主账号名称"
                            clearable>
                        </el-input>
                        <!-- <el-select
                            class="search_input leftmargin3"
                            clearable
                            v-model="advertiserForm.account_state"
                            placeholder="账号状态">
                            <el-option :label="'异常'" :value="0"></el-option>
                            <el-option :label="'正常'" :value="1"></el-option>
                        </el-select> -->
                        <el-button
                            type="primary"
                            @click="getAdvertiserList(1)"
                            class="leftmargin2"
                            size="small">查询
                        </el-button>
                    </div>
                    <el-button v-if="activeIndex==='1'" type="primary" size="small" @click="showAddDialog">新增广告账号</el-button>
                </div>
            </div>
            <div class="search_top">
                <div class="account_box">
                    <div class="account_title">
                        <div>广告账户详情</div>
                        <el-button class="refresh el-icon-refresh-right" size="small" :loading="loading" @click="getAdvertiserList(2)"></el-button>
                    </div>
                    <el-table
                        :data="advertiserList"
                        v-loading="loading"
                        element-loading-text="加载中..."
                        style="width: 100%; margin-bottom: 22px; font-size: 14px"
                        :header-cell-style="tableHeaderStyle"
                        :cell-style="{ height: 54 + 'px', padding: 0 + 'px' }">
                        <el-table-column prop="advertiser_id" label="ID" width="150"></el-table-column>
                        <el-table-column prop="advertiser_name" min-width="200" label="账号名称">
                            <template slot-scope="scope">
                                {{scope.row['qc_ad_advertiser_account.advertiser_name'] || scope.row.advertiser_name}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="ad_shop.advertiser_name" min-width="200" label="管家账号名称">
                            <template slot-scope="scope">
                                {{scope.row['ad_shop.advertiser_name']||scope.row['qc_ad_shop.advertiser_name']}}
                            </template>
                        </el-table-column>
                        
                        <el-table-column prop="account_state" width="140" label="账户状态">
                            <template slot-scope="scope">
                                <span v-if="scope.row.account_state === '异常'" class="abnormal">异常</span>
                                <span v-else class="normal">正常</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="ad_shop.valid_endTime" min-width="180" label="授权截止时间">
                            <template slot-scope="scope">
                                {{ scope.row['ad_shop.valid_endTime']||scope.row['qc_ad_shop.valid_endTime'] | formatTime }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="create_time" width="180" label="创建时间">
                            <template slot-scope="scope">
                                {{ scope.row['ad_shop.create_time']||scope.row['qc_ad_shop.create_time'] | formatTime }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="-" label="操作" min-width="300">
                            <template slot-scope="scope">
                                <!-- <el-button type="text">添加广告主</el-button> -->
                                <!-- <i class="el-icon-more"></i> -->
                                <!-- <el-button type="text">重新绑定</el-button>
                                <el-button type="text">自动绑定</el-button>
                                <el-button type="text">停投</el-button>
                                <el-button type="text">编辑</el-button> -->
                                <el-button type="text">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <kt-pag
                        :pageCount="advertiserForm.count"
                        :currentPage="advertiserForm.page"
                        :limit="advertiserForm.limit"
                        @onChange="handleAdPageChange">
                    </kt-pag>
                </div>
            </div>
        </div>
        
    </div>
</template>

<script>
import KtPag from "../Comm/KtPag.vue";
import moment from "moment";
import { mapState } from "vuex";
import Coding from "../Coding/Coding";
import { hasPermission } from "../../permission/index";
export default {
    data() {
        return {
            mediaRadio: 1,
            hasPermission: hasPermission,
            // 顶部导航栏默认index
            activeName:'juliangTabPane',//巨量/千川
            activeIndex: "1",
            loading:false,//表格加载等待
            accountList:[],//管家账号列表
            accountQueryInfo:{//管家账号
                account_id:'',
                advertiser_name:'',
                account_state:'',
                page:1,
                limit:10,
                count:0,
            },
            advertiserList:[],//广告主账号
            advertiserForm:{//广告主账号
                advertiser_id:'',
                advertiser_name:'',
                page:1,
                limit:10,
                count:0,
            },
            syncLoding:false,//同步的等待
            syncIndex:-1,//第几个正在同步
        };
    },
    filters: {
        //格式化时间
        formatTime(val) {
            if (val && moment(val).isValid())
                return moment(val).format("YYYY-MM-DD HH:mm:ss");
            else return "-";
        },
    },
    mounted() {
        this.initPage();
    },
    created() {
        this.$store.commit("onCollapse", false);
    },
    methods: {
        hasPerms(perm) {
            return hasPermission(perm);
        },
        async initPage() {
            this.getAccountList(1);
        },
        //设置表头行的样式
        tableHeaderStyle() {
            return "color:#000000;font-wight:500;font-size:14px;height:54px;background:#FAFAFA;";
        },
        handleClick(){
            if(this.activeIndex=='1'){
                this.accountQueryInfo={//管家账号
                    account_id:'',
                    advertiser_name:'',
                    account_state:'',
                    page:1,
                    limit:10,
                    count:0,
                }
                this.getAccountList(1);
            }else{
                this.advertiserForm ={//广告主账号
                    advertiser_id:'',
                    advertiser_name:'',
                    page:1,
                    limit:10,
                    count:0,
                }
                this.getAdvertiserList(1);
            }
        },
        //切换目录
        handleMenuSelect(key) {
            this.activeIndex = key;
            if(key=='1'){
                this.getAccountList(1);
            }else{
                this.getAdvertiserList(1);
            }
        },
        //获取管家账号数据
        getAccountList(type){
            this.loading = true;
            if(type===1){
                this.advertiserForm.page = 1;
            }
            if(this.activeName ==='juliangTabPane'){
                let params = {...this.accountQueryInfo};
                delete params.count;
                this.$api.account.getJlMDAccount(params).then(res=>{
                    this.accountList = res.data.rows;
                    this.accountQueryInfo.count = res.data.count;
                    this.loading = false;
                })
            }else if(this.activeName ==='qianchuanTabPane'){
                let params = {...this.accountQueryInfo};
                delete params.count;
                this.$api.account.getQCMDAccount(params).then(res=>{
                    this.accountList = res.data.rows;
                    this.accountQueryInfo.count = res.data.count;
                    this.loading = false;
                })
            }
        },
        // 获取广告主账号数据
        getAdvertiserList(type){
            this.loading = true;
            if(type===1){
                this.advertiserForm.page = 1;
            }
            if(this.activeName ==='juliangTabPane'){
                let params = {...this.advertiserForm};
                delete params.count;
                this.$api.account.getJlOwnerAccount(params).then(res=>{
                    this.advertiserList = res.data.rows;
                    this.advertiserForm.count = res.data.count;
                    this.loading = false;
                });
            }else if(this.activeName ==='qianchuanTabPane'){
                let params = {...this.advertiserForm};
                delete params.count;
                this.$api.account.getQCOwnerAccount(params).then(res=>{
                    this.advertiserList = res.data.rows;
                    this.advertiserForm.count = res.data.count;
                    this.loading = false;
                });
            }
        },
        //处理分页-管家账号
        handlePageChange({page,limit}){
            this.accountQueryInfo.page = page;
            this.accountQueryInfo.limit = limit;
            this.getAccountList(2);
        },
        //分页-广告主账号
        handleAdPageChange({page,limit}){
            this.advertiserForm.page = page;
            this.advertiserForm.limit = limit;
            this.getAdvertiserList(2);
        },
        //新增广告账号
        showAddDialog(){

            if(this.activeName ==='juliangTabPane'){
                window.open('https://open.oceanengine.com/audit/oauth.html?app_id=1636584505073672&state='+this.userInfo.id+'&scope=%5B10111200%2C2%2C3%2C4%2C5%2C130%2C10111300%2C10101000%2C9%2C12%2C10101100%2C110%2C10111100%5D&material_auth=1&redirect_uri=http%3A%2F%2F8.140.163.18%3A20030%2Fcallback%2Ftoutiao&rid=srn0g2hjje','_blank')
            }else if(this.activeName ==='qianchuanTabPane'){
                window.open("https://qianchuan.jinritemai.com/openapi/qc/audit/oauth.html?app_id=1709866550059060&state="+this.userInfo.id+"&scope=%5B20120000%2C21000000%2C22000000%2C23000000%2C24000000%5D&material_auth=1&redirect_uri=http%3A%2F%2F8.140.163.18%3A20030%2Fcallback%2Fqianchuan&rid=5j9beg1zahv","_blank")
            }
        },
        //同步店铺数据
        syncData(item,index) {
            this.syncLoding = true;
            this.syncIndex = index;
            let params = {
                shop_id:item.shop_id,
                account_id:item.account_id
            }
            if(this.activeName ==='juliangTabPane'){
                this.$api.comApi.syncJlAccountHisData(params).then(res=>{
                    this.$message({
                        type:res.status==='0'?'success':'error',
                        message:res.status==='0'?'同步成功':res.message
                    })
                    this.getAdvertiserList(1);
                    this.syncLoding = false;
                })
            }else if(this.activeName ==='qianchuanTabPane'){
                this.$api.comApi.syncQcAccountHisData(params).then(res=>{
                    this.$message({
                        type:res.status==='0'?'success':'error',
                        message:res.status==='0'?'同步成功':res.message
                    })
                    this.getAdvertiserList(1);
                    this.syncLoding = false;
                })
            }
        }


    },
    components: {
        KtPag,
        Coding,
    },
    computed: {
        ...mapState({
            userInfo: (state) => state.app.userInfo,
        }),
    },
    
};
</script>
<style lang='scss'>
.AccountAut {
    .bt {
        height: 32px !important;
        line-height: 32px !important;
        padding: 0 16px !important;
        font-size: 14px;
        align-items: center;
    }
    .el-table {
        .el-button--text {
            font-size: 14px;
        }
    }
    .normal {
        color: #555658;
        font-size: 14px;
    }
    .abnormal {
        color: #f5222d;
        font-size: 14px;
    }
    .kt-page {
        text-align: right !important;
    }
    
    .search_top {
        .search_box {
            .search_input {
                width: 176px;
                margin-right: 20px;
            }
            
            .el-input__inner {
                height: 32px;
                background: #F2F2F2;
                border:none;
            }
            .el-input__icon {
                height: 32px;
                line-height: 32px;
            }
        } 
    }
    .refresh{
        display: flex;
        width: 32px;
        box-sizing: border-box;
        justify-content: center;
        background: #F2F2F2;
        border: none;
    }
}
</style>